export const DRAGGABLE_COMBOBOX_CHIP_EVENT_TYPE = "DRAGGABLE_COMBOBOX_CHIP";
